/* Extracted from sections/fon-checkout-redirect.liquid (was an inline parser-time jQuery block).
   Loaded with `defer` from the same file, so it runs after footer jQuery. */
/* Load-order guard: this file is loaded from a section/snippet that renders EARLIER in
   the document than jquery.min.js in the footer script zone. Deferred scripts execute in
   document order, not load order, so without this wrapper the first jQuery/$ call here
   throws ReferenceError and kills the whole block.

   DOMContentLoaded fires only after every deferred script has run, so jQuery is guaranteed
   defined by then. Do not unwrap this. */
document.addEventListener('DOMContentLoaded', function () {
var _progressInterval = null;

  function showRedirectDialog() {
    var $overlay = $('#checkout-overlay');
    var $bar     = $('#redirect-progress-bar');

    $overlay.addClass('visible');

    var width = 0;
    _progressInterval = setInterval(function () {
      var step = width < 60 ? 1.5 : width < 85 ? 0.5 : 0.1;
      width = Math.min(width + step, 90);
      $bar.css('width', width + '%');
    }, 80);
  }

  function hideRedirectDialog() {
    var $overlay = $('#checkout-overlay');
    var $bar     = $('#redirect-progress-bar');

    clearInterval(_progressInterval);
    $bar.css('width', '100%');

    setTimeout(function () {
      $overlay.removeClass('visible');
      setTimeout(function () { $bar.css('width', '0%'); }, 300);
    }, 300);
  }

showRedirectDialog();

$(function () {

  var orderFrom = 'checkout-direct';
  var params    = new URLSearchParams(window.location.search);
  var product   = params.get('product');
  var offer     = params.get('offer');
  var sku       = params.get('onefit-sku');

  // ⏳ Delay before firing — avoids Cloudflare bot detection
  setTimeout(function () {

    switch (product) {
      case 'onefit':
        checkoutOneFit(offer);
      break;
      case 'comprehensive':
        checkoutComprehensive(offer);
      break;
      case 'onelife':
        checkoutOneLife(offer);
      break;
    }

  }, 1500); // adjust if still getting blocked (try 2000–3000)



  function checkoutComprehensive(offer) {

    switch (offer) {

      case '90d':
        var variantID     = parseInt(params.get('variant-id'))      || 691885310136;
        var sellingPlanID = parseInt(params.get('selling-plan-id')) || 52524592791736;

        var formData = {
          items: [
            {
              id: variantID,
              quantity: 5,
              selling_plan: sellingPlanID,
              properties: {
                '_BUNDLE' : 'comprehensive_90d',
                '_bundle_group_id' : 'comprehensive_90d_' + variantID,
                "_bundle_group_product" : true,
                "_bundle_group_product_row" : 1,
                "_bundle_group_product_multiplier" : 5,
                '_offer' : 'comprehensive_90d_' + variantID,
                '_offer_product_type' : 'primary',
                '_order_from'               : orderFrom
              }
            }
          ]
        };

        formData.items.push({
          id: 52884772323512,
          quantity: 3,
          selling_plan: 691914834104,
          properties : {
            '_BUNDLE' : 'comprehensive_90d',
            '_bundle_group_id' : 'comprehensive_90d_' + variantID,
            "_bundle_group_product" : true,
            "_bundle_group_product_row" : 2,
            "_bundle_group_product_multiplier" : 3,
            '_offer' : 'comprehensive_90d_' + variantID,
            '_offer_product_type' : 'primary',
            '_order_from' : 'comprehensive-challenger'
          }
        });

        if (!bottleOOS) {
          formData.items.push({
            id: 53301741289656,
            quantity: 2,
            properties: {
              '_offer'             : 'onefit_90d_' + variantID,
              '_offer_product_type': 'free',
            }
          });
        }

        

        // 1️⃣ Clear cart
        $.post('/cart/clear.js').always(function () {

          // 2️⃣ Add items (small extra delay between clear and add)
          setTimeout(function () {

            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: JSON.stringify(formData),
              dataType: 'json',
              contentType: 'application/json',
            })
            .then(function () {

              // 3️⃣ Redirect
              window.location.href = '/checkout';

            })
            .fail(function (xhr) {
              hideRedirectDialog();
              console.log('Status:', xhr.status);
              console.log('Response:', xhr.responseJSON);
              console.log('Response text:', xhr.responseText);
              var msg = xhr.responseJSON && xhr.responseJSON.description
                ? xhr.responseJSON.description
                : 'Something went wrong. Please try again.';
              alert(msg);
            });

          }, 500); // delay between clear and add

        });

        break;
    }
  }

  
  function checkoutOneFit(offer) {

    switch (offer) {

      case '90d':
        var variantID     = parseInt(params.get('variant-id'))      || 691885310136;
        var sellingPlanID = parseInt(params.get('selling-plan-id')) || 52524592791736;

        var formData = {
          items: [
            {
              id: variantID,
              quantity: 5,
              selling_plan: sellingPlanID,
              properties: {
                '_BUNDLE'                   : 'onefit_90d',
                '_bundle_group_id'          : 'onefit_90d_' + variantID,
                '_bundle_group_product'     : true,
                '_bundle_group_product_row' : 1,
                '_offer'                    : 'onefit_90d_' + variantID,
                '_offer_product_type'       : 'primary',
                '_order_from'               : orderFrom
              }
            }
          ]
        };

        if (!bottleOOS) {
          formData.items.push({
            id: 53301741289656,
            quantity: 1,
            properties: {
              '_offer'             : 'onefit_90d_' + variantID,
              '_offer_product_type': 'free',
            }
          });
        }

        if (!frotherOOS && !(!window.FonCartDrawer || FonCartDrawer.FROTHER_GIFTS_DISABLED !== false) /* frother gift hidden 2026-09-22: off unless FROTHER_GIFTS_DISABLED is explicitly false */) {
          formData.items.push({
            id: 51843757670584,
            quantity: 1,
            properties: {
              '_offer'             : 'onefit_90d_' + variantID,
              '_offer_product_type': 'free',
            }
          });
        }

        // 1️⃣ Clear cart
        $.post('/cart/clear.js').always(function () {

          // 2️⃣ Add items (small extra delay between clear and add)
          setTimeout(function () {

            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: JSON.stringify(formData),
              dataType: 'json',
              contentType: 'application/json',
            })
            .then(function () {

              // 3️⃣ Redirect
              window.location.href = '/checkout';

            })
            .fail(function (xhr) {
              hideRedirectDialog();
              console.log('Status:', xhr.status);
              console.log('Response:', xhr.responseJSON);
              console.log('Response text:', xhr.responseText);
              var msg = xhr.responseJSON && xhr.responseJSON.description
                ? xhr.responseJSON.description
                : 'Something went wrong. Please try again.';
              alert(msg);
            });

          }, 500); // delay between clear and add

        });

        break;
    }
  }



  function checkoutOneLife(offer) {

    switch (offer) {

      case '90d':
        var variantID     = parseInt(params.get('variant-id'))      || 52533861712056;
        var sellingPlanID = parseInt(params.get('selling-plan-id')) || 691889602744;

        var formData = {
          items: [
            {
              id: variantID,
              quantity: 3,
              selling_plan: sellingPlanID,
              properties: {
                '_BUNDLE'                   : 'onelife_90d',
                '_bundle_group_id'          : 'onelife_90d_' + variantID,
                '_bundle_group_product'     : true,
                '_bundle_group_product_row' : 1,
                '_offer'                    : 'onelife_90d_' + variantID,
                '_offer_product_type'       : 'primary',
                '_order_from'               : orderFrom
              }
            }
          ]
        };

        if (!bottleOOS) {
          formData.items.push({
            id: 53301741289656,
            quantity: 1,
            properties: {
              '_offer'             : 'onelife_90d_' + variantID,
              '_offer_product_type': 'free',
            }
          });
        }

        if (!frotherOOS && !(!window.FonCartDrawer || FonCartDrawer.FROTHER_GIFTS_DISABLED !== false) /* frother gift hidden 2026-09-22: off unless FROTHER_GIFTS_DISABLED is explicitly false */) {
          formData.items.push({
            id: 51843757670584,
            quantity: 1,
            properties: {
              '_offer'             : 'onefit_90d_' + variantID,
              '_offer_product_type': 'free',
            }
          });
        }

        // 1️⃣ Clear cart
        $.post('/cart/clear.js').always(function () {

          // 2️⃣ Add items (small extra delay between clear and add)
          setTimeout(function () {

            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: JSON.stringify(formData),
              dataType: 'json',
              contentType: 'application/json',
            })
            .then(function () {

              // 3️⃣ Redirect
              window.location.href = '/checkout';

            })
            .fail(function (xhr) {
              hideRedirectDialog();
              console.log('Status:', xhr.status);
              console.log('Response:', xhr.responseJSON);
              console.log('Response text:', xhr.responseText);
              var msg = xhr.responseJSON && xhr.responseJSON.description
                ? xhr.responseJSON.description
                : 'Something went wrong. Please try again.';
              alert(msg);
            });

          }, 500); // delay between clear and add

        });

        break;

      case '90d_duo':
        var variantID     = parseInt(params.get('variant-id'))      || 52533861712056;
        var sellingPlanID = parseInt(params.get('selling-plan-id')) || 691889602744;

        var formData = {
          items: [
            {
              id: variantID,
              quantity: 6,
              selling_plan: sellingPlanID,
              properties: {
                '_BUNDLE'                   : 'onelife_90d_duo',
                '_bundle_group_id'          : 'onelife_90d_duo_' + variantID,
                '_bundle_group_product'     : true,
                '_bundle_group_product_row' : 1,
                '_offer'                    : 'onelife_90d_duo_' + variantID,
                '_offer_product_type'       : 'primary',
                '_order_from'               : orderFrom
              }
            }
          ]
        };

        if (!bottleOOS) {
          formData.items.push({
            id: 53301741289656,
            quantity: 2,
            properties: {
              '_offer'             : 'onelife_90d_duo_' + variantID,
              '_offer_product_type': 'free',
            }
          });
        }

        if (!frotherOOS && !(!window.FonCartDrawer || FonCartDrawer.FROTHER_GIFTS_DISABLED !== false) /* frother gift hidden 2026-09-22: off unless FROTHER_GIFTS_DISABLED is explicitly false */) {
          formData.items.push({
            id: 51843757670584,
            quantity: 2,
            properties: {
              '_offer'             : 'onefit_90d_' + variantID,
              '_offer_product_type': 'free',
            }
          });
        }

        // 1️⃣ Clear cart
        $.post('/cart/clear.js').always(function () {

          // 2️⃣ Add items (small extra delay between clear and add)
          setTimeout(function () {

            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: JSON.stringify(formData),
              dataType: 'json',
              contentType: 'application/json',
            })
            .then(function () {

              // 3️⃣ Redirect
              window.location.href = '/checkout';

            })
            .fail(function (xhr) {
              hideRedirectDialog();
              console.log('Status:', xhr.status);
              console.log('Response:', xhr.responseJSON);
              console.log('Response text:', xhr.responseText);
              var msg = xhr.responseJSON && xhr.responseJSON.description
                ? xhr.responseJSON.description
                : 'Something went wrong. Please try again.';
              alert(msg);
            });

          }, 500); // delay between clear and add

        });

        break;
    }
  }

});
});
